<script setup>

import router from '@/router';

import {onMounted, ref} from 'vue';
import {getNotifications} from '@/services/NotificationService';
import {formatDate} from '@/helper';
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const notifications = ref([]);

function navigateTo(to) {
  router.push(to);
}

onMounted(async () => {
  getNotifications()
      .then((response) => {
        notifications.value = response;
      });
})

</script>
<template>
  <div class="page-section">
    <div class="page-section__heading">
        <div class="row">
          <div class="col-3">
            <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> Zpět</a>
          </div>
          <div class="col-6 text-center">
                  <div class="page-section__title">
              {{ t('notifications.notifications') }}
          </div>
        </div>
      </div>
    </div>
    <div class="page-section__content">
          <div class="mb-4">
            <div class="row mb-3">
              <div class="col-12">
                <div class="card shadow">
                  <div class="card-body">
                    <div class="table-container">
                      <table class="table table--last-to-right table--cells-py-0">
                        <thead>
                          <tr>
                            <th scope="col">
                              {{ t('notifications.subject') }}
                            </th>
                            <th scope="col">
                              {{ t('notifications.text') }}
                            </th>
                            <th scope="col">
                              {{ t('notifications.date') }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="notification of notifications" :key="notification">
                            <td>
                              {{notification.subject}}
                            </td>
                            <td>
                              {{notification.text}}
                            </td>
                            <td>
                              {{formatDate(notification.created_at, 'd.m.Y H:i')}}
                            </td>
                          </tr>
                          <tr v-if="!notifications.length">
                            <td colspan="3" class="table__empty-td">
                              <div class="table__empty-text">
                                {{ t('notifications.no_notifications_yet') }}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
  </div>
</template>

